import i18n from "@/i18n";

export const cancellationPolicyText = (product) => {
  let descriptions = [];

  if (!product.rate.refundable) {
    descriptions.push(
      `<li class="mb-2"><span class="text-main">♦</span> ${i18n.t(
        "reservation.nonRefundableRate"
      )}</li>`
    );
  } else {
    const policies =
      product.rate?.cancellationPolicies?.cancelPolicyInfos || [];

    if (policies.length === 0) {
      descriptions.push(
        `<li class="mb-2"><span class="text-main">♦</span> ${i18n.t(
          "reservation.freeCancellation"
        )}</li>`
      );
    } else {
      descriptions = policies.map((policy) => {
        const { cancelTime, amount, currency, type, timezone } = policy;

        const date = new Date(cancelTime).toLocaleString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          timeZone: timezone || "UTC",
        });

        let penalty = "";
        if (type === "amount") {
          penalty = `${currency} ${amount.toFixed(2)}`;
        } else if (type === "percent") {
          penalty = `${amount}%`;
        } else {
          penalty = `${amount} ${currency}`;
        }

        return `<li class="mb-2"><span class="text-main">♦</span> ${i18n.t(
          "reservation.cancelPolicyText",
          { date, timezone, penalty }
        )}</li>`;
      });
    }
  }

  return `<ul>${descriptions.join("")}</ul>`;
};

export const rateDetails = (product, room = false) => {
  const parts = [product.rate.boardName];
  if (room && product.rate.name) {
    parts.unshift(product.rate.name);
  }

  parts.push(
    product.rate.refundable
      ? i18n.t("reservation.refundableRate")
      : i18n.t("reservation.nonRefundableRate")
  );

  return parts.join(", ").replace(/, ([^-]+)$/, " - $1");
};

export const rateDetailsText = (product) => {
  const items = [
    `<li class="mb-2"><span class="text-main">♦</span> ${rateDetails(
      product
    )}</li>`,
  ];

  return `<ul>${items.join("")}</ul>`;
};
